import { addMonths, isAfter, isBefore, isSameMonth, startOfDay } from 'date-fns';

/**
 * Дата в прошлом приводится к сегодняшней
 * Дата в будущем месяце центрирует календарь на десктопе при 3 месяцах
 */
export const useCalendarNormalization = (
	outDate: Date,
	selectedDates: Date[],
	openDate: Date,
	isMobile: boolean,
	desktopMonthCount: number
) => {
	const today = startOfDay(new Date());
	const outDateStartOfDay = outDate ? startOfDay(outDate) : null;

	const isOutDateInPast = outDateStartOfDay ? isBefore(outDateStartOfDay, today) : false;
	const isOutDateInFutureMonth = outDateStartOfDay
		? isAfter(outDateStartOfDay, today) && !isSameMonth(outDateStartOfDay, today)
		: false;

	const normalizedOutDate = isOutDateInPast ? today : outDateStartOfDay;

	const normalizedSelectedDates =
		isOutDateInPast && selectedDates?.length ? [today, ...selectedDates.slice(1)] : selectedDates;

	let normalizedOpenDate = openDate;

	if (normalizedOutDate) {
		normalizedOpenDate = normalizedOutDate;

		if (!isMobile && isOutDateInFutureMonth && desktopMonthCount === 3) {
			normalizedOpenDate = addMonths(normalizedOutDate, -1);
		}
	}

	return { isOutDateInPast, normalizedSelectedDates, normalizedOpenDate };
};
